import request from '@/config/axios'

export interface O2oServiceFavoriteVO {
  id?: number
  userId?: number
  catalogServiceId?: number
  serviceName?: string
  coverImage?: string
  basePrice?: number
  createTime?: string
}

export const O2oFavoriteApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/favorite/page', params })
  },
}
